/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_appsync_graphqlEndpoint": "https://excrjpeqdreqfeahymlvuvyhea.appsync-api.eu-west-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-2lzkqeet4nc6lc5cuam3zc4m7u",
    "aws_cognito_identity_pool_id": "eu-west-1:9843be69-c425-4310-bf1a-4b9d936563b8",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_tsYHq0vou",
    "aws_user_pools_web_client_id": "4ej085h801mgtv4t7vgqmqq1l6",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "adviserpartnershc101449-prod",
    "aws_user_files_s3_bucket_region": "eu-west-1"
};


export default awsmobile;
